var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.params.value > '0')?_c('i',{staticClass:"fas fa-circle",class:{ 'initialized': _vm.params.value === '2', 'finished': _vm.params.value === '3', 'notInitialized': _vm.params.value === '1' }}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.pdrStatus)+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61432dc","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/operational/pci/components/PdrDepartamentoStatusRenderer.vue
// module id = null
// module chunks = 